import { render, staticRenderFns } from "./CompanyBanner.vue?vue&type=template&id=0a4f2121&scoped=true"
import script from "./CompanyBanner.vue?vue&type=script&lang=js"
export * from "./CompanyBanner.vue?vue&type=script&lang=js"
import style0 from "./CompanyBanner.vue?vue&type=style&index=0&id=0a4f2121&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4f2121",
  null
  
)

export default component.exports